import React from 'react';

export const NotFoundView = () => {
  return (
    <div className="min-h-screen w-full relative">
      <img 
        src="/images/404.webp" 
        alt="404 Page Not Found" 
        className="w-full h-screen object-cover object-bottom"
      />
      <div className="absolute top-[15%] left-1/2 -translate-x-1/2 text-center">
        <h1 className="text-9xl font-bold text-white mb-4">404</h1>
        <h2 className="text-4xl font-semibold text-white">Page Not Found</h2>
      </div>
    </div>
  );
}; 